export function toggleSort(sorted, field) {
    if (!sorted.field) {
        return;
    } else if (sorted.field === field && sorted.rule === "desc") {
        sorted.field = "id";
        sorted.rule = "desc";
    } else {
        sorted.rule =
            sorted.rule === "desc" || sorted.field === "id" ? "asc" : "desc";
        sorted.field = field;
    }
}

export function toggleCustomSort(sorted, field, name) {
    if (field === name) {
        if (sorted.field === field && sorted.rule === "asc") {
            sorted.field = "name";
            sorted.rule = "asc";
        } else if (sorted.field === field && sorted.rule === "desc") {
            sorted.rule = "asc";
        } else if (sorted.field === "error_" + field) {
            sorted.field = field;
            sorted.rule = "desc";
        } else {
            sorted.field = "error_" + field;
            sorted.rule = "desc";
        }
    }
}
